import React from "react";
import Header from "../header";
import { apiCall_domainV2 } from "../api";
import axios from "axios";
import Spinner from "../Spinner/Spinner";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

class PopularCarsItems extends React.Component {
  state = {
    data: [],
    loading: true,
    currentPage: parseInt(this.props.match.params.page) || 1,
  };
  componentDidMount() {
    const Headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domainV2}/customer/popular_cars`, {
        headers: Headers,
      })
      .then((res) => {
        this.setState({
          data: res.data.data,
          loading: false,
        });
      });
  }
  render() {
    const pushProducts = (popularCar) => {
      this.props.history.push({
        pathname: `/popular_cars/${popularCar.id}/1/3`,
        state: popularCar,
      });
    };
    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <div className="specialSection">
            <Header
              showSearchBar={true}
              title={"لیست خودروها"}
              showBasket={true}
            />
            <div className="popularCarsMainCard">
              {this.state.data.map((popularCar) => (
                <div
                  onClick={() => pushProducts(popularCar)}
                  className="popularCarItem"
                >
                  <div className="Image">
                    <img src={popularCar.image} alt="tire" />
                  </div>
                  <div className="popularCarInfo">
                    <span className="name">{popularCar.car}</span>
                    <span className="type">{popularCar.type}</span>
                  </div>
                </div>
              ))}
            </div>
            <div className="pag col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <Stack spacing={2}>
                <Pagination />
              </Stack>
            </div>
            {typeof this.props.total === "number" &&
              this.props.total > 0 &&
              this.props.items.length !== 0 && (
                <div className="pag col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <Stack spacing={2}>
                    <Pagination
                      count={this.props.last_page}
                      page={this.props.current_page}
                      onChange={(e, value) => {
                        this.props.history.push(`?page=${value}`);
                      }}
                    />
                  </Stack>
                </div>
              )}
          </div>
        )}
      </>
    );
  }
}
export default PopularCarsItems;
